import { ActivityAlertSettingsRepository } from "@core/data/repositories/activity-alert-settings.repository";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { ActivityAlertSettings } from "@core/domain/models/activity-alert-settings.model";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";

@injectable()
export class UpdateMyActivityAlertSettingsUseCase {
    constructor(
        @inject(ActivityAlertSettingsRepository)
        private readonly repository: ActivityAlertSettingsRepository,
    ) {}

    execute(
        settings: ActivityAlertSettings,
    ): Promise<Either<FallbackError, ActivityAlertSettings>> {
        return this.repository.updateMy(settings);
    }
}
